import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { Link } from 'react-router-dom';

const Unauthorized: React.FC = () => {
    return (
        <Box
            sx={{
                textAlign: 'center',
                padding: '2rem',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                height: '70vh',
            }}
        >
            <Typography variant="h1" sx={{ fontSize: '6rem', fontWeight: 'bold', marginBottom: '1rem' }}>
                401
            </Typography>
            <Typography variant="h6" sx={{ marginBottom: '1rem' }}>
                Pro přístup k této stránce musíte být přihlášeni.
            </Typography>
            <Button variant="contained" color="primary" component={Link} to="/">
                Zpět na úvodní stránku
            </Button>
        </Box>
    );
};

export default Unauthorized;
